import type { HierarchyItemWithLevels } from '@openx/types/hierarchyItem';
import { useCallback, useRef, useState } from 'react';

type UseHierarchyStateProps = {
  initialName: string | undefined;
  onOptionSelect: (item: HierarchyItemWithLevels | null) => void;
  value: string;
};

export const useHierarchyState = ({ initialName, onOptionSelect, value }: UseHierarchyStateProps) => {
  const lastSelected = useRef<string | null>(initialName ?? value);
  const [inputPhrase, setInputPhrase] = useState<string>(initialName ?? value);

  const onOptionAdd = useCallback(
    (_event, item: HierarchyItemWithLevels | null) => {
      if (item) {
        setInputPhrase(item.name);
        onOptionSelect(item);
        lastSelected.current = item.name;
      } else {
        setInputPhrase('');
        onOptionSelect(null);
        lastSelected.current = null;
      }
    },
    [onOptionSelect]
  );

  const onClose = useCallback(() => {
    if (lastSelected.current !== null) {
      setInputPhrase(lastSelected.current);
    } else {
      setInputPhrase('');
    }
  }, []);

  const handleInputChange = useCallback((_e, value: string, reason: string) => {
    if (reason === 'input' || reason === 'clear') setInputPhrase(value);
  }, []);

  return {
    inputPhrase,
    onOptionAdd,
    onClose,
    handleInputChange,
  };
};
